import React, { useEffect } from 'react'
import { useBreakpoints } from '../../../../../components/breakpoints/BreakpointsProvider'
import { alpha, Divider, Stack, Typography, useTheme } from '@mui/material'
import SignupFormConjoint from '../../components/home/SignupFormConjoint'
import { connect } from 'react-redux'
import { getConjoint } from '../../conjoint/conjointSelector'
import { useHistory } from 'react-router-dom'
import { MAIN_PATH_UNIVERS } from '../../../../../constant/path'
import { FormattedMessage } from 'react-intl'


const HomeSignupConjoint = ({
	                            // @ts-ignore
	                            conjoint
                            }) => {
	const theme = useTheme()
	const history = useHistory()

	useEffect(() => {
		if(conjoint === undefined || conjoint.numindiv === undefined){
			history.push(MAIN_PATH_UNIVERS.LOGIN_EA)
		}
	}, [])

	return (
		<Stack>
			<Stack
				direction="column"
				sx={{ backgroundColor:"#F7F5F4", paddingBottom: "63px"}}
				bgcolor={alpha('#e0e4ff', 0.65)}
				alignItems="center"
				spacing="80px"
			>
				<img style={{ position: "absolute", alignSelf:"start", height: '52px', marginTop: '8px', marginLeft: '32px' }} src={`${window.location.origin}/blobs/medias/s/logo_gerep/gerep_logo.dc371007.png`} alt="logo" />
				<Stack
					direction="column"
					spacing="24px"
					boxShadow={12}
					padding="24px"
					style={{
						maxWidth: '900px',
						borderRadius: '6px',
						backgroundColor: theme.palette.background.paper
					}}
				>
					<Typography variant="h2">
						<FormattedMessage id="activationConjoint.form.signup.title" />
					</Typography>
					<Divider />
					<SignupFormConjoint conjoint={conjoint}/>
				</Stack>
			</Stack>
		</Stack>
	)
}

const actions = {

}

const mapStateToProps = (state: any) => ({
	conjoint: state.pages && getConjoint(state)
})

export default connect(mapStateToProps, actions)(HomeSignupConjoint)

